var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthcare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 55",
    style: {
      enableBackground: "new 0 0 56 55"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.8,9.2c2.5,0,5.3,1.4,8.2,4.1c2.5-2.3,5.8-3.6,9.3-3.6c3,0,5.8,1.2,7.9,3.3c4.9,5.1,4.9,13.1,0,18.2 l-15.6,15c-0.9,0.9-2.4,0.9-3.3,0L15.7,36c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0l10.6,10.2c0.2,0.2,0.4,0.2,0.6,0l15.5-15 c4.1-4.3,4.1-11.2,0-15.5c-1.7-1.8-4.1-2.7-6.5-2.7h-0.1C34,11.7,31,13,28.8,15.3c-0.4,0.4-1.1,0.4-1.5,0 c-2.7-2.7-5.3-4.1-7.5-4.1c-2.8,0-5.6,1.1-7.5,3.2c-2.2,2.3-3.3,5.3-3.1,8.4c0,0.5-0.4,1-0.9,1c-0.5,0-1-0.4-1-0.9 C7,19.3,8.3,15.7,10.8,13C13.2,10.6,16.4,9.2,19.8,9.2L19.8,9.2z M23,19.5c0.4,0,0.8,0.3,0.9,0.7L26.6,31l2.9-5.5 c0.2-0.3,0.5-0.6,0.9-0.6l0.1,0c0.3,0,0.6,0.2,0.7,0.5l1.8,3.3h3.9c0.5,0,1,0.4,1,1s-0.4,1-1,1h-4.5c-0.3,0-0.7-0.2-0.8-0.5 l-1.2-2.2l-3.2,6.2c-0.2,0.3-0.5,0.5-0.9,0.5h-0.1c-0.4,0-0.7-0.3-0.8-0.7l-2.6-10.3l-2.8,7.2c-0.1,0.3-0.4,0.6-0.8,0.6 c-0.4,0-0.7-0.1-0.9-0.4l-2.1-3.4l-1.6,2.6c-0.2,0.3-0.5,0.5-0.8,0.5l-4,0c-0.5,0-1-0.4-1-1s0.4-1,1-1h3.4l2.1-3.4 c0.2-0.3,0.5-0.5,0.8-0.5l0.1,0c0.3,0,0.5,0.2,0.7,0.4l1.9,3.1l3.2-8.2C22.2,19.8,22.6,19.5,23,19.5z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcare);
export default __webpack_public_path__ + "static/media/healthcare.2e7faaf9932e2da03a32fa40195da376.svg";
export { ForwardRef as ReactComponent };